import { render, staticRenderFns } from "./ExistsPageMessage.vue?vue&type=template&id=b9ff8e7e"
import script from "./ExistsPageMessage.vue?vue&type=script&lang=js"
export * from "./ExistsPageMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports